import { ChangeDetectionStrategy, Component, input, Optional  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '@program-suite/util-icons';
import { ModalService } from '../../../services/modal.service';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../snackbar/snackbar.component';

@Component({
  selector: 'lib-btn-close',
  imports: [CommonModule, IconComponent],
  templateUrl: './btn-close.component.html',
  styleUrl: './btn-close.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BtnCloseComponent {
  closeIcon = 'close';
  buttonType = input<string>('');

 constructor(
    private modalService: ModalService,
    @Optional() public snackBarRef?: MatSnackBarRef<SnackbarComponent> 
  ) {}
  
  close() {
    this.modalService.close();
  }

  closeSnackbar() {
    if (this.snackBarRef) {
      this.snackBarRef.dismiss();
    } 
  }
}
